import React from "react";
import { Link } from "react-router-dom";

export default function HomeFinalCta() {
  return (
    <section className="bg-gray-950 py-20 text-white sm:py-24" aria-labelledby="final-cta-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-3xl">
          <h2 id="final-cta-heading" className="text-3xl font-bold tracking-tight sm:text-4xl">
            Manufacturing Automation Group
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/75 sm:text-lg">
            A Metro Detroit partner for AMR and AGV integration. Systems are launched and
            supported beside live production.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
            <Link to="/who-we-are" className="btn-secondary">
              About MAG
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
